import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle, XCircle } from "lucide-react";

export default function CanvaCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const error = searchParams.get("error");

    if (error) {
      setStatus("error");
      setMessage(`Canva yetkilendirme hatası: ${error}`);
      return;
    }

    if (!code || !state) {
      setStatus("error");
      setMessage("Geçersiz callback parametreleri");
      return;
    }

    async function exchangeToken() {
      try {
        const res = await fetch(
          `${import.meta.env.VITE_API_URL || ""}/api/canva/oauth/callback`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("erc_token") || ""}`,
            },
            body: JSON.stringify({ code, state }),
          }
        );

        if (!res.ok) {
          const err = await res.json();
          throw new Error(err.error || "Token alınamadı");
        }

        setStatus("success");
        setMessage("Canva hesabı başarıyla bağlandı!");
        setTimeout(() => navigate("/settings"), 2000);
      } catch (err: any) {
        setStatus("error");
        setMessage(err.message || "Bağlantı hatası");
      }
    }

    exchangeToken();
  }, [searchParams, navigate]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="rounded-xl border border-gray-200 bg-white p-8 shadow-sm text-center max-w-md">
        {status === "loading" && (
          <>
            <Loader2 className="h-12 w-12 animate-spin text-purple-500 mx-auto mb-4" />
            <h2 className="text-lg font-semibold text-gray-900">Canva hesabı bağlanıyor...</h2>
            <p className="mt-2 text-sm text-gray-500">Lütfen bekleyin</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle className="h-12 w-12 text-emerald-500 mx-auto mb-4" />
            <h2 className="text-lg font-semibold text-gray-900">Başarılı!</h2>
            <p className="mt-2 text-sm text-gray-500">{message}</p>
            <p className="mt-1 text-xs text-gray-400">Ayarlara yönlendiriliyorsunuz...</p>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
            <h2 className="text-lg font-semibold text-gray-900">Bağlantı Hatası</h2>
            <p className="mt-2 text-sm text-red-600">{message}</p>
            <button
              onClick={() => navigate("/settings")}
              className="mt-4 rounded-lg bg-gray-100 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200"
            >
              Ayarlara Dön
            </button>
          </>
        )}
      </div>
    </div>
  );
}
